import breakpoints from "@/styles/utils/media.module.scss";

interface Props {
	tasteProfile: string;
}

export function IntroIllustration({ tasteProfile }: Props) {
	tasteProfile = tasteProfile.replace(/\s/g, "");

	return (
		<picture>
			<source
				media={`(max-width: ${breakpoints.md})`}
				src={`/taste-styles/${tasteProfile}.svg`}
				width={375}
				height={426}
			/>
			<img
				src={`/taste-styles/${tasteProfile}.svg`}
				role="presentation"
				alt=""
				loading="eager"
			/>
		</picture>
	);
}
